import { render, staticRenderFns } from "./PayoutLimits.vue?vue&type=template&id=f20c1eb8&"
import script from "./PayoutLimits.vue?vue&type=script&lang=js&"
export * from "./PayoutLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports